<template>
  <div>

    <b-card
      no-body
      class="mb-2"
    >
      <b-card-header>
        <h4 class="mb-0">
          Objects
        </h4>
        <b-card-text>
          Objects at this site
        </b-card-text>
      </b-card-header>
      <b-table
        :items="objects"
        :fields="objectFields"
        responsive
        class="mb-0"
        striped
        show-empty
        empty-text="No Objects Found"
        :busy="isBusy"
      >
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle mr-1" />
            <strong>Loading...</strong>
          </div>
        </template>
        <template
          #cell(arrow)="row"
        >
          <div v-if="row.item.devices.length > 0">
            <feather-icon
              v-if="row.detailsShowing"
              icon="ChevronDownIcon"
              class="mr-50"
              stroke-width="2"
              @click="row.toggleDetails"
            />
            <div
              v-if="row.detailsShowing"
              class="arrow-line"
            />

            <feather-icon
              v-else
              icon="ChevronRightIcon"
              class="mr-50"
              stroke-width="2"
              @click="row.toggleDetails"
            />
          </div>
        </template>
        <template
          #cell(name)="row"
        >
          <b-badge
            variant="success"
            class="mr-1"
          >
            <router-link
              :to="{
                name: 'object',
                params: {
                  id: row.item.id,
                },
              }"
            >
              {{ row.item.name }}
            </router-link>
          </b-badge>
        </template>

        <template
          #cell(devices)="row"
        >
          <b-badge
            variant="success"
            class="mr-1"
          >
            {{ row.item.devices.length }}
          </b-badge>
        </template>

        <template
          #row-details="row"
        >
          <div
            class="connecting-line"
            :class="{ 'connecting-line': row.detailsShowing }"
          >
            <b-table
              v-if="row.item.devices.length > 0"
              :items="row.item.devices"
              :fields="deviceFields"
              striped
              small
              bordered
              outlined
            >
              <template
                #cell(name)="row"
              >
                <b-badge
                  variant="success"
                  class="mr-1"
                >
                  <router-link
                    :to="{
                      name: 'device',
                      params: {
                        id: row.item.id,
                      },
                    }"
                  >
                    {{ row.item.name }}
                  </router-link>
                </b-badge>
              </template>
            </b-table>
          </div>
        </template>

      </b-table>

    </b-card>
  </div>
</template>

<script>
import {
  BTable,
  BCard,
  BCardHeader,
  BCardText,
  BBadge,
  BSpinner,
} from 'bootstrap-vue'
import { API } from 'aws-amplify'
import * as queries from '../../../../graphql/queries'

export default {
  components: {
    BTable,
    BCard,
    BCardHeader,
    BCardText,
    BSpinner,

    BBadge,

  },
  props: {
    siteInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isBusy: false,
      objects: [],
      devices: [],
      search: '',
      deviceFields: [
        { key: 'name', label: 'Name' },
        { key: 'deviceModel.name', label: 'Model' },
        { key: 'deviceModel.deviceManufacturer.name', label: 'Manufacturer' },
        { key: 'positionOnObject', label: 'Position On Object', sortable: true },
      ],
      objectFields: [
        { key: 'arrow', label: '', thStyle: { width: '1%' } },
        { key: 'name', label: 'Name' },
        { key: 'model', label: 'Model' },
        { key: 'manufacturer', label: 'Manufacturer' },
        { key: 'devices', label: 'Devices', sortable: true },
      ],
    }
  },
  created() {
    this.getSiteObjects()
  },
  methods: {
    async getSiteObjects() {
      const site = await API.graphql({
        query: queries.getSite,
        variables: {
          id: this.siteInfo.id,
        },
      })
      this.getObjectDevices(site.data.getSite.objects.items)
    },
    async getObjectDevices(objects) {
      objects.forEach(async object => {
        const devices = await API.graphql({
          query: queries.getObject,
          variables: {
            id: object.id,
          },
        })
        this.objects.push({
          ...object,
          devices: devices.data.getObject.devices.items,
        })
        this.getDeviceInfo()
      })
    },
    async getDeviceInfo() {
      this.objects.forEach(async (object, index) => {
        object.devices.forEach(async (device, deviceIndex) => {
          const deviceInfo = await API.graphql({
            query: queries.getDevice,
            variables: {
              id: device.id,
            },
          })
          this.objects[index].devices[deviceIndex] = deviceInfo.data.getDevice
        })
      })
    },
    searchFilter() {
      const search = this.search.toLowerCase()
      return row => row.name.toLowerCase().includes(search)
    },
    onRowClick(event) {
      window.location.href = `/object/${event.id}`
    },
    onDeviceRowClick(event) {
      window.location.href = `/device/${event.id}`
    },

  },
}
</script>

<style>
arrow-line {
  border-left: 2px solid #ddd;
  margin-top: 10px;
}
.connecting-line {
  padding-left: 10em;
  border-left: 2px solid #ddd;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 0.5em;

}

</style>
